import { h } from 'vue'

// Icons stacked in one box, as Font Awesome's layers did; each child can
// move and shrink with its transform prop.
// a functional component: no instance of its own
const IconLayers = (_props, { slots }) =>
  h('span', { class: 'fa-layers' }, slots.default?.())
IconLayers.displayName = 'IconLayers'

export default IconLayers
